// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --configuration=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

const packageJson = require('../../package.json');

export const environment = {
  appName: 'My B-trust: DEV',
  envName: 'DEV',
  production: false,
  apiUrl: '/cqes/api',
  mpiPaymentLink: 'https://3dsgate-dev.borica.bg/cgi-bin/cgi_link',
  reCaptcha: {
    emergency: true,
    personalId: true,
    reCaptchaSkip: true,
    automatedTestParamKey: 'auqakey',
    reCaptcha2SiteKey: '6LcVuGsUAAAAAAuK5iP6EuuWEKM9QCzsGjv2TeOl',
    invisibleCaptchaSiteKey: '6LcVuGsUAAAAAJThTlcq9SWAl3pRz1FInxTgpwhX'
  },
  maxUploadSize: 27949794,
  maxRequestSize: 69905067,
  dateFormat: 'dd.MM.yyyy',
  timeFormat: 'HH:mm',
  dateTimeFormat: 'dd.MM.yyyy HH:mm',
  signedDocExpirationTime: 7,
  displayToBeArchivedCheckbox: true,
  hideOrders: false,
  versions: {
    app: packageJson.version,
    angular: packageJson.dependencies['@angular/core'],
    ngrx: packageJson.dependencies['@ngrx/store'],
    material: packageJson.dependencies['@angular/material'],
    bootstrap: packageJson.dependencies.bootstrap,
    rxjs: packageJson.dependencies.rxjs,
    angularCli: packageJson.devDependencies['@angular/cli'],
    typescript: packageJson.devDependencies['typescript']
  },
  timeInterceptorDebug: false,
  relyingPartyName: 'cloud.b-trust.bg',
  urlEstorePurchaseCqesPackages: 'https://estore.tst.srv/oblachni-podpisi'
};
